import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const FooterContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  filter: drop-shadow(${theme.effects.boxShadow['rule-01']});
  border-radius: ${theme.shapes.borderRadius.xmd} ${theme.shapes.borderRadius.xmd} 0 0;
  padding: ${theme.spacing.sm} 0;
  background: ${theme.colors.neutral.white};
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 50;
  button {
    font-size: 13px;
    line-height: unset;
  }
`
export const FooterContent = styled.div`
  display: flex;
  width: 100%;

  margin: 0 ${theme.spacing.lg};
  flex-wrap: wrap;

  .contentRight {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: ${theme.spacing.sm};
  }
  .contentRightBetween {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
`

type ActionButtonProps = {
  fullfill: boolean
  globalLoading?: boolean
}

export const ActionButton = styled.button<ActionButtonProps>`
  background: ${({ fullfill }) =>
    fullfill ? theme.colors.primary.main : theme.colors.neutral.white};
  color: ${({ fullfill }) => (fullfill ? theme.colors.neutral.white : theme.colors.primary.main)};
  border-radius: ${theme.shapes.borderRadius.sm};
  border: 0;
  font-weight: ${theme.typography.weight.lg};
  font-family: ${theme.typography.family.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: ${theme.spacing.xs};
  transition: all 0.3s ease-in-out;
  padding: ${theme.spacing.sm} ${theme.spacing.xm};

  :disabled {
    background: ${theme.colors.neutral.clear};
    color: ${theme.colors.neutral.lighthover};
    cursor: not-allowed;
  }

  :hover {
    filter: brightness(90%);
  }

  cursor: ${({ globalLoading }) => (!globalLoading ? 'pointer' : 'wait')};
`

export const Boxes = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: center;
  margin-right: ${theme.spacing.lg};

  h1,
  h2 {
    margin: 0;
  }

  h1 {
    font-size: ${theme.typography.sizes.xs};
    font-weight: ${theme.typography.weight.lg};
    color: ${theme.colors.neutral.medium};
  }

  h2 {
    font-size: ${theme.typography.sizes.sm};
    font-weight: ${theme.typography.weight.xsm};
    color: ${theme.colors.neutral.high};
  }
`

export const MaterialBoxes = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: center;
  margin-right: ${theme.spacing.lg};
  h1,
  h2 {
    margin: 0;
  }

  h1 {
    font-size: ${theme.typography.sizes.xs};
    font-weight: ${theme.typography.weight.xsm};
    color: ${theme.colors.neutral.medium};
  }

  h2 {
    font-size: ${theme.typography.sizes.sm};
    font-weight: ${theme.typography.weight.lg};
    color: ${theme.colors.neutral.high};
  }
`

export const ResumeInfo = styled.div`
  width: 100%;
  margin-bottom: ${theme.spacing.xm};
  padding-top: ${theme.spacing.sm};

  display: flex;
  justify-content: space-between;
`

export const ResumeSide = styled.div`
  flex: 1;

  & + & {
    margin-left: ${theme.spacing['2xl']};

    @media (max-width: ${theme.breakpoints.md}px) {
      margin-left: ${theme.spacing.lg};
    }
  }
`

export const ResumeLine = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${theme.colors.neutral.lighthover};
  margin-bottom: ${theme.spacing.xs};

  span {
    font-weight: ${theme.typography.weight.lg};
    line-height: 17.3px;
    color: ${theme.colors.neutral.high};
  }

  span:first-of-type {
    font-size: ${theme.typography.sizes.xs};
  }

  span:last-of-type {
    font-size: ${theme.typography.sizes.sm};
  }

  div {
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
`
